var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25253 2.58579C1.62761 2.21071 2.13632 2 2.66675 2H7.33341C7.7016 2 8.00008 2.29848 8.00008 2.66667C8.00008 3.03486 7.7016 3.33333 7.33341 3.33333H2.66675C2.48994 3.33333 2.32037 3.40357 2.19534 3.5286C2.07032 3.65362 2.00008 3.82319 2.00008 4V13.3333C2.00008 13.5101 2.07032 13.6797 2.19534 13.8047C2.32037 13.9298 2.48994 14 2.66675 14H12.0001C12.1769 14 12.3465 13.9298 12.4715 13.8047C12.5965 13.6797 12.6667 13.5101 12.6667 13.3333V8.66667C12.6667 8.29848 12.9652 8 13.3334 8C13.7016 8 14.0001 8.29848 14.0001 8.66667V13.3333C14.0001 13.8638 13.7894 14.3725 13.4143 14.7475C13.0392 15.1226 12.5305 15.3333 12.0001 15.3333H2.66675C2.13631 15.3333 1.62761 15.1226 1.25253 14.7475C0.877462 14.3725 0.666748 13.8638 0.666748 13.3333V4C0.666748 3.46957 0.877462 2.96086 1.25253 2.58579Z",
    fill: "#07364B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3334 1.91912C13.1352 1.91912 12.945 1.99788 12.8048 2.13807L6.60207 8.34083L6.24967 9.75042L7.65926 9.39803L13.862 3.19526C14.0022 3.05507 14.081 2.86493 14.081 2.66667C14.081 2.46841 14.0022 2.27826 13.862 2.13807C13.7218 1.99788 13.5317 1.91912 13.3334 1.91912ZM11.862 1.19526C12.2523 0.805022 12.7815 0.585787 13.3334 0.585787C13.8853 0.585787 14.4146 0.805022 14.8048 1.19526C15.1951 1.5855 15.4143 2.11478 15.4143 2.66667C15.4143 3.21855 15.1951 3.74783 14.8048 4.13807L8.4715 10.4714C8.38606 10.5568 8.27901 10.6175 8.16179 10.6468L5.49512 11.3134C5.26794 11.3702 5.02761 11.3037 4.86202 11.1381C4.69644 10.9725 4.62987 10.7322 4.68667 10.505L5.35333 7.83831C5.38264 7.72109 5.44325 7.61404 5.52869 7.5286L11.862 1.19526Z",
    fill: "#07364B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.cfb83c09e9ff6896d72b7f988ac68ea2.svg";
export { ForwardRef as ReactComponent };